module.exports = __webpack_public_path__ + "img/house-projects-2.1762af57.jpg";